import { CustomTableHeader } from '../../../../components/CustomTable';
import { getTheme } from '../../../../utils/getTheme';

export type ProcessosLicitatoriosTableRow = {
  id: string | number;
  status: string;
  componenteAf: string;
  modalidade: string;
  submodalidade: string;
  denominacaoKit: string;
  denominacaoKitBool: string;
  [key: string]: any;
};

export const renderStatusExecucao = (value: string) => {
  const theme = getTheme();

  const statusStyleMap: Record<string, { bg: string; text: string }> = {
    'Em Elaboração': {
      bg: '#ffde26',
      text: '#000',
    },
    'Em Execução': {
      bg: theme.colors.azulgov,
      text: '#fff',
    },
    Encerrado: {
      bg: '#919191',
      text: '#fff',
    },
    Suspenso: {
      bg: '#e98a0f',
      text: '#fff',
    },
    Cancelado: {
      bg: '#fd2727',
      text: '#fff',
    },
  };

  const { bg, text } = statusStyleMap[value] ?? {
    bg: '#b6b6b6',
    text: '#000',
  };

  return (
    <div
      style={{
        backgroundColor: bg,
        color: text,
        padding: '10px',
        borderRadius: '4px',
        textAlign: 'center',
        fontWeight: 500,
      }}
    >
      {value}
    </div>
  );
};

export const renderComponenteAF = (value: string) => {
  const theme = getTheme();

  const componenteAFStyleMap: Record<string, { bg: string; text: string }> = {
    Básico: {
      bg: theme.colors.azulgov,
      text: '#fff',
    },
    Estratégico: {
      bg: theme.colors.verdegov,
      text: '#fff',
    },
    Especializado: {
      bg: theme.colors.amarelogov,
      text: '#000',
    },
    Oncológico: {
      bg: theme.colors.vermelho,
      text: '#fff',
    },
    Raras: {
      bg: '#09c5c5',
      text: '#fff',
    },
  };

  return (
    <>
      <span
        style={{
          backgroundColor: componenteAFStyleMap[value]?.bg ?? 'white',
          color: componenteAFStyleMap[value]?.text ?? 'black',
          padding: '10px',
          borderRadius: '4px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '1rem',
        }}
      >
        {value?.charAt(0).toUpperCase()}
      </span>
      <span style={{ marginLeft: '10px', fontWeight: 500 }}>{value}</span>
    </>
  );
};

export const renderTipoProduto = (value: string) => {
  const theme = getTheme();

  const tipoProdutoStyle = {
    bg: value === 'D' ? '#0066ff' : '#ff8800',
    text: value === 'D' ? '#fff' : '#fff',
  };

  return (
    <div style={{ width: '80px', display: 'flex', justifyContent: 'center' }}>
      <div
        style={{
          backgroundColor: tipoProdutoStyle.bg,
          color: tipoProdutoStyle.text,
          padding: '10px',
          borderRadius: '4px',
          textAlign: 'center',
          fontWeight: 500,
          //   width: '30px',
        }}
      >
        {value === 'D' ? 'Den' : 'Kit'}
      </div>
    </div>
  );
};

export const headersProcessosLicitatorios: CustomTableHeader<ProcessosLicitatoriosTableRow>[] =
  [
    { text: '', width: 1, key: '', renderable: false },
    {
      text: 'ID',
      width: 6,
      key: 'id',
      fieldType: 'number',
      textAlign: 'center',
    },
    {
      text: 'Status',
      width: 12,
      key: 'status',
      fieldType: 'select',
      renderCell: (value) => renderStatusExecucao(value),
    },
    {
      text: 'Componente AF',
      width: 12,
      key: 'componenteAf',
      fieldType: 'select',
      renderCell: (value) => renderComponenteAF(value),
    },
    {
      text: 'Modalidade',
      width: 10,
      key: 'modalidade',
      fieldType: 'select',
    },
    {
      text: 'Submodalidade',
      width: 10,
      key: 'submodalidade',
      fieldType: 'select',
    },
    {
      text: 'Tipo',
      width: 5,
      key: 'denominacaoKitBool',
      fieldType: 'select',
      renderCell: (value) => renderTipoProduto(value),
    },
    {
      text: 'Denominação ou Kit',
      width: 50,
      key: 'denominacaoKit',
      fieldType: 'text',
    },
  ];
